import { useTranslate } from '@ur/react-hooks'
import { parseISO } from 'date-fns'
import React from 'react'
import { useQuery } from '@apollo/client'
import styled from 'styled-components'
import { format } from 'util/date-fns'
import { DriverCardQuery, DriverCardQueryVariables } from '..'
import { DRIVER_CARD_QUERY } from '../queries'
import { Input, InputArea, ProfileCard } from '../UserProfile/components'

const Wrapper = styled(ProfileCard)`
  display: grid;
  grid-template-columns: 1fr auto;
  grid-template-areas:
    'header header header'
    'name driverId expiryDate';
  gap: 1.5rem;

  header {
    grid-area: header;
  }

  ${props => props.theme.media.largePad} {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'name'
      'driverId'
      'expiryDate';
    gap: 1rem;
  }

  ${props => props.theme.media.mobile} {
    grid-template-columns: 1fr;
    grid-template-areas:
      'header'
      'name'
      'driverId'
      'expiryDate';
    gap: 1rem;
  }
`

export interface DriverCardProps {
  cardId: string
}

export const DriverCard: React.VFC<DriverCardProps> = ({ cardId }) => {
  const { data, loading } = useQuery<DriverCardQuery, DriverCardQueryVariables>(
    DRIVER_CARD_QUERY,
    { variables: { id: cardId } }
  )
  const translations = {
    labels: useTranslate({
      name: 'common.name',
      cardNumber: 'users.driver-card',
      expires: 'common.expires-at',
      title: 'users.active-driver-card',
    }),
  }
  const card = data?.driverCard

  // TODO: Add loading view on final design
  return loading ? null : (
    <Wrapper gridArea="driverCard">
      <header>
        <h3>{translations.labels.title}</h3>
      </header>
      <InputArea area="name">
        <label>{translations.labels.name}</label>
        <Input
          editing={false}
          value={card?.user.fullName ?? ''}
          onChange={() => void 0}
        />
      </InputArea>
      <InputArea area="driverId">
        <label>{translations.labels.cardNumber}</label>
        <Input
          editing={false}
          value={`${card?.cardIssuingMemberState}${card?.driverIdentification}`}
          onChange={() => void 0}
        />
      </InputArea>
      <InputArea area="expiryDate">
        <label>{translations.labels.expires}</label>
        <Input
          editing={false}
          value={card && card.expiresAt ? format(parseISO(card.expiresAt), 'MM/yy') : '-'}
          onChange={() => void 0}
        />
      </InputArea>
    </Wrapper>
  )
}
